import { render, staticRenderFns } from "./MovementList.vue?vue&type=template&id=6385d01d"
import script from "./MovementList.vue?vue&type=script&lang=js"
export * from "./MovementList.vue?vue&type=script&lang=js"
import style0 from "./MovementList.vue?vue&type=style&index=0&id=6385d01d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports